import IUDefObReducer from "./reducers/IUDefOb";
import IUzReducer from "./reducers/IUz";
import IAkcFrmSkupUzReducer from "./reducers/IAkcFrmSkupUz"
import IAkcFrmpodSkupUzReducer from "./reducers/IAkcFrmpodSkupUz"
import IFrmSqlReducer from "./reducers/IFrmSql";
import IApiKlucReducer from "./reducers/IApiKluc";

const reducer = async (action, data, state, prevState, customReducer) => {
  switch (state.primaryField) {
    case "IUDefOb":
      return IUDefObReducer(action, data, state, prevState);
    case "IUz":
      return IUzReducer(action, data, state, prevState);
    case "IAkcFrmSkupUz":
      return IAkcFrmSkupUzReducer(action, data, state, prevState);
    case "IAkcFrmpodSkupUz":
      return IAkcFrmpodSkupUzReducer(action, data, state, prevState);
    case "IApiKluc":
      return IApiKlucReducer(action, data, state, prevState)
    case "ISpFrmSql":
    case "IFrmSqlUz":
      return IFrmSqlReducer(action, data, state, prevState);
    default:
      return customReducer ? await customReducer(action, data, state, prevState) : state;
  }
}

export default reducer;